import rightCard from "./RightWorkCard.module.css";
import { Link } from "react-router-dom";
import sharedW from "./SharedWork.module.css"

function RightWorkCard ({
    img = "",
    h1 = "Title",
    p = "Lorem ipsum dolor sit amet consectetur. Tristique nisl convallis amet habitasse nunc. Cursus interdum euismod feugiat nisl id sed dolor purus. Vestibulum eget ac maecenas libero mattis nulla nibh porta.",
    time = "Time spent",
    tags = ["Tag 1", "Tag 2", "Tag 3", "Tag 4"],
    linkTo = ""
}) {
    // Reverse the tags array safely without mutating the original
    const reversedTags = [...tags].reverse();

    return (
        <Link to={linkTo} className={`${sharedW.link} ${rightCard.link}`} data-cursor="true">
            <main id={sharedW.card}>
                <div className={sharedW.card}>
                    <img className={rightCard.mobileImg} src={img} alt={h1} loading="lazy"/>
                    <div className={`${sharedW.content} ${rightCard.content}`}>
                        <div className={sharedW.description}>
                            <h1 className={sharedW.h1}>{h1}</h1>
                            <p className={sharedW.p}>{p}</p>
                        </div>
                        <div className={rightCard.mobileStuff}>
                            <h3 className={sharedW.h3}>{time}</h3>
                            <p className={sharedW.dot}>•</p>
                            <div className={sharedW.tags}>
                                {tags.map((tag, index) => (
                                    <div key={index} className={sharedW.tag}>
                                        <p>{tag}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className={`${sharedW.stuff} ${rightCard.stuff}`}>
                            <div className={sharedW.tags}>
                                {reversedTags.map((tag, index) => (
                                    <div key={index} className={sharedW.tag}>
                                        <p>{tag}</p>
                                    </div>
                                ))}
                            </div>
                            <p className={sharedW.dot}>•</p>
                            <h3 className={sharedW.h3}>{time}</h3>
                        </div>
                    </div>
                    <img className={`${sharedW.img} ${rightCard.img}`} src={img} alt={h1} loading="lazy"/>
                </div>
            </main>
        </Link>
    );
}

export default RightWorkCard;